import { getTenantId, removeProtocol } from '@/Helpers/Helper'

export const BASE_URL = "//" + getTenantId() + removeProtocol(process.env.VUE_APP_KOBOEAT_BASE_API_URL)